<template>
  <div
    class="waiver"
    :class="showFullWaiver && 'full'"
    name="text-area-honda-waiver"
    id="text-area-honda-waiver"
    ref="containerRef"
  >
    <slot />
  </div>
</template>

<style scoped lang="scss">
.waiver {
  width: 100%;
  overflow-y: scroll;
  height: 30rem;
  border: 1px solid #cdcdcd;
  border-radius: 4px;
  padding: 20px 10px;

  .full {
    height: auto;
  }
}

:deep(p) {
  margin-bottom: 15px;
}
</style>

<script setup>
import { ref } from 'vue';

defineProps({
  showFullWaiver: { type: Boolean, required: false },
});

const containerRef = ref();
const resetToTop = () => {
  containerRef.value.scrollTo({ top: 0, behavior: 'smooth' });
};

defineExpose({ resetToTop });
</script>
